import AOS from "aos";
import "aos/dist/aos.css";
import Layout from "components/layout";
import SplashScreen from "components/splashScreen";
import { lazy, useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { getSupplierProfile } from "redux/Slice/supplierProfileSlice/supplierProfileSlice";
import ProtectedRoutes from "routes/protectedRoutes";
import ScreenRoutes from "routes/screenRoutes";
import { register } from "swiper/element/bundle";
import { LOCAL_STORAGE_KEYS } from "utils/localStorageKeys";
import "./firebase";
const SignIn = lazy(() => import("components/authentication/SignIn"));
const Verification = lazy(() =>
  import("components/authentication/verification/Verification")
);

const App = () => {
  const token = localStorage.getItem(LOCAL_STORAGE_KEYS?.TOKEN);
  register();

  const { isUserLoggedIn } = useSelector(
    (state) => ({
      isUserLoggedIn: state.auth.isUserLoggedIn,
    }),
    shallowEqual
  );

  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 4000);
  }, []);

  useEffect(() => {
    if (token) {
      dispatch(getSupplierProfile());
    }
  }, [token, dispatch]);

  useEffect(() => {
    AOS.init({
      disable: "fade-down",
      disableMutationObserver: false,
    });

    window.addEventListener("scroll", () => {
      AOS.refreshHard();
    });

    return () => {
      window.removeEventListener("scroll", () => {
        AOS.refreshHard();
      });
    };
  }, []);

  return (
    <>
      {loading ? (
        <SplashScreen />
      ) : (
        <>
          <Router>
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />

              <Route
                path="/signin"
                element={
                  isUserLoggedIn ? (
                    <Navigate to="/dashboard" replace />
                  ) : (
                    <SignIn />
                  )
                }
              />
              <Route
                path="/verification"
                element={
                  isUserLoggedIn ? (
                    <Navigate to="/dashboard" replace />
                  ) : (
                    <Verification />
                  )
                }
              />
              <Route path="/" element={<ProtectedRoutes />}>
                <Route path="/" name="layout" element={<Layout />}>
                  {ScreenRoutes.map((route, idx) => {
                    return (
                      <Route
                        key={`Layout_${idx}`}
                        path={route.path}
                        name={route.name}
                        element={route.element}
                      />
                    );
                  })}
                </Route>
              </Route>
            </Routes>
          </Router>
          <Toaster position="right" />
        </>
      )}
    </>
  );
};

export default App;
